import { BaseApiClient } from '../../../lib/api/BaseApiClient';

// LandingApi — public catalog endpoints (categories, services, sub-services, etc.).
// Extends BaseApiClient; get/post return the already-unwrapped `result` payload.
class LandingApi extends BaseApiClient {
  constructor() {
    super('Landing', { public: true }); // browse endpoints — headersWithoutToken
  }

  getCategories() {
    return this.get('/GetCategory');
  }

  getServices(subCategoryID) {
    return this.get(`/GetServices?subCategoryID=${subCategoryID}`);
  }

  getSubServices(serviceID, packageID) {
    return this.get(`/GetSubServices?serviceID=${serviceID}&packageID=${packageID}`);
  }

  getSubServiceDetail(subServiceID) {
    return this.get(`/GetSubServiceDetail?subServiceID=${subServiceID}`);
  }

  popularServices() {
    return this.get('/PopularServices');
  }

  advertisement() {
    return this.get('/Advertisement');
  }

  discountedServices() {
    return this.get('/DiscountedServices');
  }

  serviceVideos() {
    return this.get('/ServiceVideos');
  }

  getCoupons() {
    return this.get('/GetCoupons');
  }

  theme() {
    return this.get('/Theme');
  }

  searchSubServices({ searchKey, subCategoryID, page = 1, pageSize = 20 }) {
    return this.post('/GetSubServiceByKey', { searchKey, subCategoryID, page, pageSize });
  }
}

export const landingApi = new LandingApi();

// ── Backward-compatible named exports ───────────────────────────
// Preserve the original function signatures so existing imports keep working.
export const getCategories       = (...args) => landingApi.getCategories(...args);
export const getServices         = (...args) => landingApi.getServices(...args);
export const getSubServices      = (...args) => landingApi.getSubServices(...args);
export const getSubServiceDetail = (...args) => landingApi.getSubServiceDetail(...args);

export { toSlug, fmt } from '../../../shared/utils/formatters';
export { CATEGORY_STYLE, DEFAULT_STYLE } from '../../../lib/constants/categoryStyles';
